import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class WasteTableHeader extends Component {

  static Layout = [
    { column: "wasteStream", width: 4, name:"Stream" },
    { column: "wasteContainer", width: 4, name:"Container" },
    { column: "weightQuantity", name: "Quantity" },
    { column: "wasteDestination", width: 2, name: "Destination" },
    { column: "wastePeriod", width: 2, name: "Period" },
    { column: "submissionDate", width: 2, name: "Submission Date" }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={WasteTableHeader.Layout}/>
    )
  }
}